import axios from 'axios'
import {Message} from 'iview'
import api from './api'
import Qs from 'qs'

// global.baserUrl = "http://localhost/index.php";
global.baserUrl = "http://www.topmdrt.cn/../index.php";


var instance = axios.create({
 	baseURL: baserUrl,
 	headers: {
		// 'Content-Type': 'application/json;charset=UTF-8;',
		'Content-Type': 'application/x-www-form-urlencoded'
		// 'Access-Control-Allow-Origin': '*'
	 },
});

global.$http = {
	get: (url,params) =>{
		url += (url.indexOf('?')<0?'?':'&')+setparams(params);
		return new Promise((resolve,reject) =>{
			instance.get(url).then((res) =>{
				resolve(res.data);
			}).catch((e) =>{
				console.log(e);
				//reject(e);
			});
		})
	    
	},
	
	post: (url,params) =>{
		return new Promise((resolve,reject) =>{
			params = Qs.stringify(params)
			instance.post(url,params).then((res) =>{
				resolve(res.data);
			}).catch((e) =>{
				console.log(e);
				//reject(e);
			})
		})
	},
	error:'0',
	api:api
}



function setparams(data){
	let paramStr = '';
	for(var k in data){                                                                                 
		var value = data[k] != undefined ? data[k] : '';
		paramStr += `&${k}=${encodeURIComponent(value)}`;//encodeURIComponent   把字符串作为 URI 组件进行编码。
	};
	
	return paramStr ? paramStr.substring(1) : '';
}



// WEBPACK FOOTER //
// ./src/base/js/http.js